import {
  Alert,
  Loader,
  Stack,
  Strong,
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Text,
} from 'braid-design-system';

import { useOrganizations } from '../OrganizationContext.tsx';

import { OrganizationRow } from './OrganizationRow.tsx';

import { usePermissions } from '#src/hooks/auth.tsx';

export const OrganizationsList = () => {
  const {
    loading: organizationsLoading,
    organizations,
    error,
  } = useOrganizations();
  const { integrationPartnerUuid } = usePermissions();

  const currentPartner = organizations.find(
    (org) => org.integrationPartnerUuid === integrationPartnerUuid,
  );

  return (
    <Stack space="gutter">
      {error ? (
        <Alert tone="critical">
          <Stack space="small">
            <Text>
              We couldn’t load the organization list. Please try again later.
            </Text>
            <Text size="small">{error}</Text>
          </Stack>
        </Alert>
      ) : null}
      {organizationsLoading && <Loader />}
      {!(organizationsLoading || error) && currentPartner && (
        <Stack space="gutter">
          <Text>
            You are currently logged into{' '}
            <Strong>{currentPartner?.name}</Strong>
          </Text>
          <Table label="Organizations">
            <TableHeader>
              <TableRow>
                <TableHeaderCell>
                  <Text>Organization Name</Text>
                </TableHeaderCell>
                <TableHeaderCell>
                  <Text>Role</Text>
                </TableHeaderCell>
                <TableHeaderCell align="right">
                  <Text>Actions</Text>
                </TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {organizations.map((organization) => (
                <OrganizationRow
                  key={organization.id}
                  organization={organization}
                  isCurrentPartner={
                    organization.integrationPartnerUuid ===
                    currentPartner.integrationPartnerUuid
                  }
                />
              ))}
            </TableBody>
          </Table>
        </Stack>
      )}
    </Stack>
  );
};
